import addClickHandler from '../events/addClickHandler';
import scrollTo from '../animation/scrollTo';
import getScrollPosition from '../media/getScrollPosition';
import forEachSelector from '../elements/forEachSelector';
import addStartupScript from '../events/addStartupScript';
import getHeaderOffset from '../media/getHeaderOffset';
import getElementTop from '../elements/getElementTop';
import leadformStartTracking from '../tracking/leadform_start_tracking';
import { openLeadform } from '../elements/leadForm';

const selector = [
  '.lead-constructor__panel--welcome.active .js-lead-constructor__next',
  '.form-wizard--hero .leadform-panel.active:first-child [data-trigger=next]',
].join();
const getLeadformTop = () => getElementTop('.leadform') - getHeaderOffset();

export function startWizard() {
  const buttons = document.querySelectorAll(selector);
  if (buttons.length === 1) buttons[0].click();
}

export function handleClickButton(event) {
  // TODO: move line 15, 25 and the if(y > 0) checks to scrollTo.js
  // this was done in AX-960 but caused a lot of other jest tests to then need changes
  // I was advised to undo it and create https://varsity.atlassian.net/browse/AX-1015
  const leadform = document.querySelector('.leadform, .form-wizard');
  if (leadform) {
    leadformStartTracking(event.target);
    openLeadform(leadform);
  }

  // wait for leadform to be in place before calculating where to scroll to
  setTimeout(() => {
    const y = getScrollPosition();
    const leadformTop = getLeadformTop();

    if (y !== leadformTop) {
      scrollTo(leadformTop);
      setTimeout(startWizard, 600);
    } else {
      startWizard();
    }
  }, 1);
}

export function leadformButtonClick(event) {
  leadformStartTracking(event.target);
  if (getScrollPosition() > 0) scrollTo(getLeadformTop());
}

export function setup() {
  const leadformButton = document.querySelector(selector);
  if (leadformButton) {
    addClickHandler(leadformButton, leadformButtonClick);
  }
  forEachSelector('.js-get-started', (button) =>
    addClickHandler(button, handleClickButton)
  );
}

addStartupScript(setup);
